import {
  COLOUR_ROLES,
  LAYOUT_KEYS,
  PRESENCE_KEYS,
  RADIUS_KEYS,
  SPACE_KEYS,
} from "./keys";

/**
 * Legacy variable names mapped onto the `--typ-*` tokens
 *
 * Existing components keep reading `--md-sys-color-*`, `--mdui-color-*`,
 * `--borderRadius-*`, etc. while they are migrated to `--typ-*` directly.
 * @returns CSS variables referencing the tokens
 */
export function createCompatVariables(): Record<string, string> {
  const vars: Record<string, string> = {
    // helper variables
    "--unset-fg": "red",
    "--unset-bg": "linear-gradient(to right, red, blue)",

    // message size
    "--message-size": "var(--typ-message-size)",
    "--message-group-spacing": "var(--typ-message-group-spacing)",

    // emoji size
    "--emoji-size": "var(--typ-emoji-size)",
    "--emoji-size-medium": "var(--typ-emoji-size-medium)",
    "--emoji-size-large": "var(--typ-emoji-size-large)",

    // effects
    "--effects-blur-md": "var(--typ-effect-blur)",
    "--effects-invert-black": "var(--typ-effect-invert-black)",
    "--effects-invert-light": "var(--typ-effect-invert-light)",

    // transitions
    "--transitions-fast": "var(--typ-motion-fast)",
    "--transitions-medium": "var(--typ-motion-medium)",

    // font
    "--fonts-primary": "var(--typ-font-ui)",
    "--fonts-monospace": "var(--typ-font-mono)",
  };

  for (const key of PRESENCE_KEYS) {
    vars[`--brand-presence-${key}`] = `var(--typ-color-presence-${key})`;
  }

  for (const key of RADIUS_KEYS) {
    vars[`--borderRadius-${key}`] = `var(--typ-radius-${key})`;
  }

  for (const key of SPACE_KEYS) {
    vars[`--gap-${key}`] = `var(--typ-space-${key})`;
  }

  for (const key of LAYOUT_KEYS) {
    vars[`--layout-${key}`] = `var(--typ-layout-${key})`;
  }

  for (const role of COLOUR_ROLES) {
    vars[`--md-sys-color-${role}`] = `var(--typ-color-${role})`;
    vars[`--mdui-color-${role}`] = `var(--typ-rgb-${role})`;
  }

  return vars;
}
